async function extractFrames(url: string, fps = 25): Promise<string[]> {
    if (!Number.isFinite(fps) || fps <= 0) {
        fps = 25;
    }

    // New Promise
    const promise = new Promise<string[]>(function (resolve): any {
        let seekResolve: (() => void) | null = null;

        // Create element (video)
        const elVideo = document.createElement('video');

        // Create event (seeked)
        elVideo.addEventListener('seeked', function (): any {
            if (seekResolve) {
                seekResolve();
            }
        });

        // Create event (loaded data)
        elVideo.addEventListener('loadeddata', function (): any {
            void (async function (): Promise<any> {
                const elCanvas = document.createElement('canvas');
                const context = elCanvas.getContext('2d');
                const frames: string[] = [];

                if (context == null) {
                    resolve(frames);
                    return;
                }

                //
                elCanvas.width = elVideo.videoWidth;
                elCanvas.height = elVideo.videoHeight;

                //
                const duration = elVideo.duration;

                if (!Number.isFinite(duration) || duration <= 0) {
                    resolve(frames);
                    return;
                }

                const interval = 1 / fps;
                let currentTime = 0;

                while (currentTime < duration) {
                    elVideo.currentTime = currentTime;

                    //
                    await new Promise<void>((resolveSeek): any => (seekResolve = resolveSeek));

                    // Draw Image
                    context.drawImage(elVideo, 0, 0, elVideo.videoWidth, elVideo.videoHeight);

                    //
                    const base64ImageData = elCanvas.toDataURL();
                    frames.push(base64ImageData);

                    currentTime += interval;
                }

                // Resolve
                resolve(frames);
            })();
        });

        // Set video src *after* listening to events in case it loads so fast that the events occur before we were listening
        elVideo.src = url;
    });

    //
    return promise;
}

export { extractFrames };
